<div [ngClass]="{ 'flex flex-col gap-4 frame pb-5 my-2': true, 'border-red-500': globalError | async }">
  <!-- Header -->
  <div
    class="flex flex-col 2xl:flex-row gap-4 items-start 2xl:items-center justify-between bg-surface-50 dark:bg-surface-800 rounded-t-lg p-5"
    *ngIf="(disabled | async) === false">
    <div class="flex flex-row gap-4 justify-between 2xl:justify-start w-full">
      <p-button type="button" [label]="'dac.form.addShortlistMember' | translate" (onClick)="addRow()"
        [disabled]="(disabled | async) || !hasRemainingOptions()">
        <i class="pi pi-plus"></i>
      </p-button>

      <p-button type="button" [label]="'common.text_groups.remove_all' | translate" severity="secondary"
        (onClick)="clearAll()" [disabled]="(disabled | async) || selectedValues.length === 0">
        <i class="pi pi-trash"></i>
      </p-button>
    </div>

    <p-autoComplete [(ngModel)]="searchControlValue" [suggestions]="suggestions" (completeMethod)="search($event)"
      (onSelect)="onSearchSelect($event)" field="name" appendTo="body"
      [disabled]="(disabled | async) || !hasRemainingOptions()" placeholder="Rechercher un membre"
      class="w-full 2xl:w-[300px]" styleClass="w-full 2xl:w-[300px]" inputStyleClass="w-full 2xl:w-[300px]">
    </p-autoComplete>
  </div>

  <!-- Rows -->
  <div *ngFor="let val of selectedValues; let i = index; trackBy: trackByFn"
    class="flex gap-4 p-5 items-center justify-center">
    <div class="flex flex-col gap-2 w-full">
      <label [for]="'shortlist-' + uid + i" class="text-xs font-bold">
        {{ 'dac.form.member' | translate }}
      </label>

      <p-select *ngIf="!isArray(val)" [options]="allOptions" optionLabel="name" optionValue="code" appendTo="body" [ngModel]="val"
        (ngModelChange)="updateValue(i, $event)" [disabled]="(disabled | async) === true" class="w-full">
      </p-select>

      <p-multiSelect *ngIf="isArray(val) && !displayAsList" [options]="allOptions" optionLabel="name" optionValue="code" appendTo="body" [ngModel]="val"
        (ngModelChange)="updateValue(i, $event)" [disabled]="(disabled | async) === true" class="w-full">
      </p-multiSelect>

      <p-multiSelect *ngIf="isArray(val) && displayAsList" [options]="allOptions" optionLabel="name" optionValue="code" appendTo="body" [ngModel]="val"
        (ngModelChange)="updateValue(i, $event)" [disabled]="(disabled | async) === true" class="w-full">
        <ng-template pTemplate="selectedItems">
          <ul class="list-disc pl-5 m-0 py-2" *ngIf="$any(val) && $any(val).length > 0">
            <li *ngFor="let code of $any(val)">{{ getOptionName(code) }}</li>
          </ul>
          <div *ngIf="!$any(val) || $any(val).length === 0" class="py-2 text-gray-400">{{ 'common.text_groups.text_empty_list' | translate }}</div>
        </ng-template>
      </p-multiSelect>

      <p class="text-xs text-red-500 font-bold" *ngIf="(errors | async)?.[i]">
        {{ (errors | async)?.[i] }}
      </p>
    </div>

    <!-- Remove -->
    <div class="mt-5">
      <button type="button" (click)="removeRow(i)" [disabled]="disabled | async">
        <i [ngClass]="['pi pi-eraser', (disabled | async) ? 'text-gray-200' : 'hover:text-red-500']"></i>
      </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="selectedValues.length === 0"
    class="flex items-center justify-center p-5 text-gray-400 dark:text-gray-500">
    <p class="text-sm">{{ 'common.text_groups.text_empty_list' | translate }}</p>
  </div>
</div>